import { createSelector } from 'reselect'
import type { User } from 'types/User'
import 'types/User'
import type { Follow } from 'types/User/Follow'
import 'types/User/Follow'
import { getUser } from './helpers'
export const getFollow = createSelector([getUser], (user: User): Follow => user.follow || [])